import "./VerifiedSharingAccount.css";
import { setLoading } from "../../../../redux/loading/loadingSlice";
import { toastify } from "../../../../helpers/toast/toastify";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import check from "../../../../assets/images/check.svg";
import discord from "../../../../assets/images/discord.svg";
import FloatingDropdownWithArrow from "../../../sharedPages/CommonComponents/FloatingDropdownWithArrow/FloatingDropdownWithArrow";
import FloatingTextFiled from "../../../sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import telegram from "../../../../assets/images/telegram.jpg";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { setRefetchSpecificUser } from "../../../../redux/multicommunity/multicommunity.js";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";

const VerifiedSharingAccount = ({ user }) => {
  const api = useApi();
  const dispatch = useDispatch();

  const [connectedSocial, setConnectedSocial] = useState("");
  const [discordData, setDiscordData] = useState({
    channelName: "",
    serverId: "",
  });
  const [formErrors, setFormErrors] = useState({
    channelName: false,
    chatId: false,
    serverId: false,
  });
  const [isConnected, setIsConnected] = useState(false);
  const [showChannelName, setShowChannelName] = useState(false);
  const [showDisconnectButton, setShowDisconnectButton] = useState(false);
  const [showSaveButton, setShowSaveButton] = useState(false);
  const [socialChannelVaue, selectedSocialChannel] = useState("");
  const [telegramData, setTelegramData] = useState({ chatId: "" });

  const handleSocialChannelChange = (value) => {
    selectedSocialChannel(value);
    setConnectedSocial("");
    setDiscordData({ channelName: "", serverId: "" });
    setIsConnected(false);
    setShowChannelName(false);
    setShowDisconnectButton(false);
    setShowSaveButton(false);

    setTelegramData({ chatId: "" });
  };

  const handleDiscordButtonClick = () => {
    const discordOAuthURL =
      "https://discord.com/api/oauth2/authorize?client_id=1275052346581323936&permissions=3089&scope=bot";

    window.open(discordOAuthURL, "_blank");
  };

  const handleTelegramButtonClick = () => {
    const CopyyyItBotURL = "https://t.me/CopyTrading_Results_bot";
    // const CopyyyItBotURL = "https://t.me/MyCopyBot_dev_bot";

    window.open(CopyyyItBotURL, "_blank");
  };

  const handleServerIdChange = (e) => {
    const newServerId = e.target.value;

    setDiscordData({
      ...discordData,
      serverId: newServerId,
    });
    setShowChannelName(newServerId.trim() !== "");
  };

  const handleChannelNameChange = (e) => {
    const newChannelName = e.target.value;

    setDiscordData({
      ...discordData,
      channelName: newChannelName,
    });
    setShowSaveButton(showChannelName && newChannelName.trim() !== "");
  };

  const handleChatIdChange = (e) => {
    const newChatId = e.target.value;

    setTelegramData({
      ...telegramData,
      chatId: newChatId,
    });
    setShowSaveButton(newChatId.trim() !== "");
  };

  const handleSaveButton = async () => {
    try {
      if (connectedSocial === "Discord") {
        await saveDiscord();
      } else if (connectedSocial === "Telegram") {
        await saveTelegram();
      }
    } catch (error) {
      toastify(error?.message || "Failed to save settings", "error");
    }
  };

  const saveDiscord = async () => {
    if (!discordData?.channelName) {
      toastify("Channel name is missing.", "error");
      throw new Error("Channel name missing");
    }

    if (!discordData?.serverId) {
      toastify("Server ID is missing.", "error");
      throw new Error("Server ID missing");
    }

    if (discordData?.channelName?.length > 30) {
      const errorMessage = "Channel name must be between 1 and 30 in length.";
      toastify(errorMessage, "error");
      throw new Error(errorMessage);
    }

    dispatch(setLoading(true));

    try {
      const requestBody = {
        name: discordData?.channelName,
        serverId: discordData?.serverId,
      };

      const response = await api(
        "post",
        "social/verifyTradeDiscord",
        requestBody
      );

      if (response?.status) {
        dispatch(setRefetchSpecificUser(true));

        setDiscordData({ serverId: "", channelName: "" });
      } else {
        throw new Error(response?.message);
      }
    } catch (error) {
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  };

  const saveTelegram = async () => {
    if (!telegramData?.chatId) {
      toastify("Chat id is missing.", "error");
      throw new Error("Chat ID missing");
    }

    dispatch(setLoading(true));

    try {
      const requestBody = {
        chatId: telegramData?.chatId,
      };

      const response = await api(
        "post",
        "social/verifyTradeTelegram",
        requestBody
      );

      if (response?.status) {
        dispatch(setRefetchSpecificUser(true));

        setTelegramData({ chatId: "" });
      } else {
        throw new Error(response?.message);
      }
    } catch (error) {
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleSocialReset = async (platform) => {
    dispatch(setLoading(true));

    const response = await api("post", "social/verifyTradeSocialReset", {
      platform,
    });

    if (response?.status) {
      dispatch(setLoading(false));
      dispatch(setRefetchSpecificUser(true));

      handleSocialChannelChange("");
      toastify(`${platform} disconnected successfully!`, "success");
    } else {
      dispatch(setLoading(false));
      toastify(response?.message);
    }
  };

  useEffect(() => {
    if (user?.verifytradesocial) {
      const socials = user.verifytradesocial;

      if (socials.discordServerId && socials.discordChannelName) {
        setDiscordData({
          channelName: socials.discordChannelName,
          serverId: socials.discordServerId,
        });

        if (socialChannelVaue === "Discord") {
          setConnectedSocial("Discord");
          setIsConnected(true);
          setShowChannelName(true);
          setShowDisconnectButton(true);
          setShowSaveButton(false);
        }
      }

      if (socials.telegramChatId) {
        setTelegramData({
          chatId: socials.telegramChatId,
        });

        if (socialChannelVaue === "Telegram") {
          setConnectedSocial("Telegram");
          setIsConnected(true);
          setShowDisconnectButton(true);
          setShowSaveButton(false);
        }
      }
    }
  }, [socialChannelVaue, user]);

  return (
    <>
      <div
        className="VerifiedSharingAccountSection"
        id="VerifiedSharingAccount"
      >
        <div className="row align-items-start">
          <div className="col-lg-9 col-md-9 col-12">
            <p className="title">
              Share your trading results and verification links
            </p>
            <p className="subTitle">
              Select the channels to automatically share to
              {/* <InfoPopup
                contentItems={[
                  {
                    type: "heading",
                    text: "Share your trade entries + results",
                  },
                  {
                    type: "paragraph",
                    text: "Connect the socials you want us to automatically share your results to.",
                  },
                ]}
              /> */}
            </p>
          </div>
          <div className="col-lg-3 col-md-3 col-12">
            <div className="connectedChannelBox mb-20px mb-lg-0 mb-md-0">
              {(discordData?.serverId || telegramData?.chatId) && (
                <p className="">Sharing to:</p>
              )}
              {discordData?.serverId && <img alt="discord" src={discord} />}
              {telegramData?.chatId && <img alt="telegram" src={telegram} />}
            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-lg-3 col-md-4 col-12">
            <div className="mb-20px fixedWidth1440">
              <FloatingDropdownWithArrow
                id="socialChannelDropdown"
                label="Select Social Channel"
                options={["Discord", "Telegram"]}
                selectedValue={socialChannelVaue}
                setSelectedValue={handleSocialChannelChange}
              />
            </div>
          </div>

          <div className="col-lg-3 col-md-4 col-12">
            <div
              className="mb-20px fixedWidth1440 mx-auto"
              style={{ height: 55 }}
            >
              {socialChannelVaue && !showDisconnectButton && (
                <>
                  {isConnected ? (
                    <BubbleSvgButton
                      text={"Connected"}
                      type="button"
                      variant="black"
                      svgIcon={
                        <img
                          alt="connected icon"
                          src={check}
                          style={{
                            width: "21px",
                            height: "21px",
                          }}
                        />
                      }
                      svgPosition={isConnected ? "right" : null}
                      containerStyling={{
                        justifyContent: "center",
                      }}
                    />
                  ) : (
                    <BubbleSvgButton
                      onClick={() => {
                        if (socialChannelVaue === "Discord") {
                          handleDiscordButtonClick();
                        } else if (socialChannelVaue === "Telegram") {
                          handleTelegramButtonClick();
                        }
                        setIsConnected(true);
                        setConnectedSocial(socialChannelVaue);
                      }}
                      text={`Connect bot to your ${
                        socialChannelVaue === "Discord" ? "discord" : "telegram"
                      }`}
                      type="button"
                      variant="black"
                      spanTextStyling={{
                        fontSize: "13px",
                      }}
                      containerStyling={{
                        justifyContent: "center",
                        padding: "15px 5px",
                      }}
                    />
                  )}
                </>
              )}
              {showDisconnectButton && (
                <BubbleSvgButton
                  onClick={() => {
                    handleSocialReset(socialChannelVaue);
                  }}
                  text={"Disconnect"}
                  type="button"
                  variant="red"
                  containerStyling={{
                    justifyContent: "center",
                  }}
                />
              )}
            </div>
          </div>
          {connectedSocial === "Discord" && (
            <>
              <div className="col-lg-3 col-md-4 col-12">
                <div className="mb-20px fixedWidth1440 textFielRemoveShadow mx-auto">
                  <FloatingTextFiled
                    className={formErrors["serverId"] ? "invalid" : ""}
                    disabled={showDisconnectButton}
                    label="Enter Server ID"
                    onChange={handleServerIdChange}
                    placeholder="Enter Server ID"
                    value={discordData.serverId}
                    focusedAllowed={false}
                  />
                </div>
              </div>
              {showChannelName && (
                <div className="col-lg-3 col-md-4 col-12">
                  <div className="mb-20px textFielRemoveShadow fixedWidth1440 ms-auto">
                    <FloatingTextFiled
                      disabled={showDisconnectButton}
                      forLabel="monthly-price"
                      id="monthly-price"
                      label="Channel Name"
                      onChange={handleChannelNameChange}
                      placeholder="Channel Name"
                      value={discordData.channelName}
                      focusedAllowed={false}
                    />
                  </div>
                </div>
              )}
            </>
          )}
          {connectedSocial === "Telegram" && (
            <div className="col-lg-3 col-md-4 col-12">
              <div className="mb-20px textFielRemoveShadow fixedWidth1440 ms-auto">
                <FloatingTextFiled
                  className={formErrors["chatId"] ? "invalid" : ""}
                  disabled={showDisconnectButton}
                  label="Chat ID"
                  onChange={handleChatIdChange}
                  placeholder="Chat ID"
                  value={telegramData.chatId}
                  focusedAllowed={false}
                />
              </div>
            </div>
          )}
        </div>

        <div className="row justify-content-end">
          {showSaveButton && (
            <div className={`col-lg-3 col-md-4 col-12`}>
              <div className="mb-20px fixedWidth1440 ms-auto">
                <BubbleSvgButton
                  onClick={handleSaveButton}
                  text={"Save"}
                  type="button"
                  variant="green"
                  containerStyling={{
                    justifyContent: "center",
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default VerifiedSharingAccount;
